import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import Prism from 'prismjs'
import 'prismjs/components/prism-json'
import 'prismjs/components/prism-java'
import WithCopy from './WithCopy';
import {getApiOrigin} from "../../lib/fetch-api-server-url";

const pathPrefix = process.env.DOC_PREFIX || ''
const appOrigin = 'https://api.convertlab.com'


const Code = (props) => {
  const { language, code, path, space } = props
  const [apiOrigin, setApiOrigin] = useState('')
  const [codeData, setCodeData] = useState('')

  const replaceApi = (content) => {
    if (!apiOrigin || apiOrigin === appOrigin) return content
    else return content.replaceAll(appOrigin, apiOrigin)
  }

  const renderRef = async (ref) => {
    if (typeof ref !== 'string') {
      return 'Invalid path ' + ref
    }

    const path = ref.split('#')[0]
    const lineSelector = ref.split('#')[1]

    const refPromise = fetch(`${pathPrefix}${path}`).then(value => value.text());
    let code = await refPromise;

    const processLineSelector = (code, lineSelector) => {
      if (lineSelector && lineSelector.startsWith('L')) {
        // L1-100, L20, Line number starts from 1
        const line = lineSelector.substr(1)
        const startLineNum = parseInt(line.split('-')[0])
        const endLineNum = parseInt(line.split('-')[1] ? line.split('-')[1] : startLineNum)
        if (startLineNum <= endLineNum && startLineNum > 0 && endLineNum <= code.split('\n').length) {
          return code.split('\n').slice(startLineNum - 1, endLineNum).join('\n')
        } else {
          return 'Invalid line numbers ' + lineSelector
        }
      }

      if (lineSelector && lineSelector.startsWith('(')) {
        // add comments in source file // anchor START and // anchor END
        const anchor = lineSelector.substr(1, lineSelector.length - 2)
        const startAnchor = '@CodeSnippetStart ' + anchor
        const endAnchor = '@CodeSnippetEnd ' + anchor
        const startLineNum = code.split('\n').findIndex(line => line.includes(startAnchor))
        const endLineNum = code.split('\n').findIndex(line => line.includes(endAnchor))
        if (startLineNum !== -1 && endLineNum !== -1) {
          return code.split('\n').slice(startLineNum + 1, endLineNum).join('\n')
        } else {
          return 'Invalid anchor ' + lineSelector
        }
      }

      if (code === '') {
        return 'Add example'
      }
      return code
    }

    code = processLineSelector(code, lineSelector);

    const removeLeadingSpaces = (code) => {
      const lines = code.split('\n')
      const numberOfMinLeadingSpaces = lines.reduce((min, line) => {
        if (line.trim().length === 0) {
          return min
        }
        const leadingSpaces = line.match(/^ */)[0].length
        return Math.min(min, leadingSpaces)
      }, Infinity)
      return lines.map(line => line.slice(numberOfMinLeadingSpaces)).join('\n')
    }

    return renderCode(removeLeadingSpaces(code), '');
  }

  const renderCode = (code, path) => {
    if (code) {
      switch (language) {
        case 'json':
          return Prism.highlight(
              JSON.stringify(code, null, space),
              Prism.languages[language],
              language
          )
        case 'text':
        default:
          return Prism.highlight(code, Prism.languages[language], language)
      }
    }

    if (path) {
      return renderRef(path)
    }

    return "Add example"
  }

  useEffect(() => {
    async function fetchData() {
      const resolvedCode = await renderCode(code, path);
      setCodeData(resolvedCode)
    }

    getApiOrigin().then(apiOrigin => {
      setApiOrigin(apiOrigin)
    })

    fetchData()
  }, [])

  return (
    <div className="copyable">
      <pre className={`language-${language}`}>
        <code
          className={`language-${language}`}
          dangerouslySetInnerHTML={{
            __html: replaceApi(codeData),
          }}
        />
      </pre>
      <WithCopy />
    </div>
  )
}

Code.defaultProps = {
  language: 'text',
  code: '',
  space: 2,
}

Code.propTypes = {
  language: PropTypes.string,
  code: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  space: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default Code
